import { render } from "./all-kanban.vue?vue&type=template&id=7b967134"
import script from "./all-kanban.vue?vue&type=script&lang=js"
export * from "./all-kanban.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__